module.exports = __webpack_public_path__ + "static/img/stripe-logo.fa5fd36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stripe-logo.png
// module id = 87FR
// module chunks = 0